import styled from "styled-components";

export const Container = styled.div`
  font-size: 12px;
  background: #e6e6e6;
  width: 90%;
  border-radius: 2px;
  border-left: solid 2px;
  padding: 10px 0px 10px 1em;
  max-height: 70px;
  overflow-wrap: break-word;
  text-overflow: ellipsis;

  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  margin-bottom: 4px;
  max-lines: 2;

  p {
    font-weight: bold;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    svg {
      font-size: 16px;
    }
  }

  .preview {
    img {
      width: 3rem;
      height: 3rem;
    }
  }
`;
